import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getUser, isLoggedIn } from '../utils/auth';

export default function RequireAuth({ children, roles }) {
  const location = useLocation();
  const user = getUser();
  if (!isLoggedIn() || !user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === 'platform_admin' ? '/admin/mandanten' : '/portal'} replace />;
  }
  return children;
}

